import { render, staticRenderFns } from "./HeaderDropdownMssgs.vue?vue&type=template&id=607c8cb9&"
import script from "./HeaderDropdownMssgs.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownMssgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports